import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import {FilterAbstractModel} from 'src/models/FilterAbstractModel';

@Component({
  selector: 'app-actual-quantity-filter',
  templateUrl: './actual-quantity-filter.component.html',
  styleUrls: ['./actual-quantity-filter.component.scss']
})
export class ActualQuantityFilterComponent extends FilterAbstractModel implements OnInit, OnChanges {

  @Output() actualQtyFromEventEmitter = new EventEmitter<any>();
  @Input() filterSelected: number;

  constructor() {
    super();
  }

  ngOnInit() {
    if (this.filterSelected)
      this.optionSelected = "" + this.filterSelected;
  }

  ngOnChanges() {
    if (this.filterSelected) {
      this.optionSelected = this.filterSelected;
    }
  }

  public getElementSelected(): void {
    this.actualQtyFromEventEmitter.emit(this.optionSelected);
  }

  reset() {
    this.optionSelected = null;
  }

}
